// extracted by mini-css-extract-plugin
export default {"bing-icon":"WebSearchReferencePreview-module__bing-icon--lhPED"};